module.exports = __webpack_public_path__ + "static/mokhtar-a433a72ae6253c4b7a5364a0846cb1b0.png";